import React, { useEffect, useMemo, useState } from 'react'
import TransaksiService from '../../../services/transaksi/TransaksiService'
import UserService from '../../../services/user/UserService'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { AsyncPaginate } from 'react-select-async-paginate'
import SweetAlert from 'react-bootstrap-sweetalert'
import { formatDateString, getCurrentDateFormatted, romanNum } from '../../../utilities/Utils'
import Disposisi from '../../../utilities/Disposisi'
import PbUmkuService from '../../../services/pbumku/PbumkuService'

const ModalProsesDraft = ({ showProsesDraft, handleCloseProsesDraft, dataDisposisi, datappm, reloadList }) => {

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    const [showConfirmProsesDraft, setShowConfirmProsesDraft] = useState(false)
    const handleCloseConfirmProsesDraft = () => setShowConfirmProsesDraft(false)
    const [showProsesDraftSuccess, setshowProsesDraftSuccess] = useState(false)
    const [showProsesDraftFailed, setshowProsesDraftFailed] = useState(false)
    const [rowPenugasan, setRowPenugasan] = useState(null)
    const [loadingSave, setLoadingSave] = useState(false)

    const [valuePejabatOpt, setValuePejabatOpt] = useState(null)

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [dataMutu, setDataMutu] = useState({})
    const [dataKomoditi, setDataKomoditi] = useState([])
    const [dataKontainer, setDataKontainer] = useState([])

    useEffect(() => {
        if (!datappm) return
        const fetchDataPpm = async () => {
            try {
                const resMutu = await transaksiService.getPpmMutuById(datappm.nomorAju)
                setDataMutu(resMutu.data)
                const resDetil = await transaksiService.listPpmDetil(datappm.nomorAju, 0, 0, 0, 10)
                setDataKomoditi(resDetil.data.data)
                const resKontainer = await transaksiService.listPpmContainer(datappm.nomorAju, null, 0, 10)
                setDataKontainer(resKontainer.data.data)
            } catch (error) {
                console.log(error)
            }
        }
        fetchDataPpm()
    }, [datappm, transaksiService])

    async function loadOptionPejabatTtd(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangePejabatOpt = e => {
        setValuePejabatOpt(e)
    }

    const SavePenugasan = (dataDisposisi) => {
        setShowConfirmProsesDraft(true)
        setRowPenugasan(dataDisposisi)
    }

    const handleClickProsesDraft = async () => {
        setLoadingSave(true)
        try {
            const respNomor = await pbumkuService.ambilNomorService('PPM_SPT_DR', datappm.kdUpt, currentYear, localStorage.getItem('username'))
            // let noSuratTugasTemp = datappm.kdUpt + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + Math.floor(100000 + Math.random() * 900000)
            let noSuratTugas = respNomor.data.uraianPusat + '/' + respNomor.data.kodePusat + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut
            let jsonDraft = { ...rowPenugasan, noTugas: noSuratTugas, tglTugas: getCurrentDateFormatted(), nipPejabat: valuePejabatOpt.nip, nmPejabat: valuePejabatOpt.nama, createdBy: localStorage.getItem("userId"), createdAt: new Date() }
            const _resDraft = await transaksiService.addPenugasan(jsonDraft)
            if (_resDraft.data.kode === '200') {
                const respCert = await pbumkuService.ambilNomorService('PPM_NOCERT', datappm.kdUpt, currentYear, localStorage.getItem('username'))
                let nomorSeri = respCert.data.kodePusat + '-S-' + respCert.data.nomorUrut + '-' + currentYear
                let jsonHcMutu = {
                    trHcMutuPK: {
                        nomorAju: datappm.nomorAju,
                        noProses: noSuratTugas,
                    },
                    kdHcm: 'H',
                    noHcMutu: nomorSeri,
                    noSeriMutu: 'Draft',
                    kdNegaraAsal: 'ID',
                    nmNegaraAsal: 'Indonesia',
                    unitPusat: datappm.kdUpt,
                    unitDaerah: datappm.kdUpt,
                    alUnitDaerah: '-',
                    telpUnitDaerah: '-',
                    nmPengirim: datappm.namaTrader,
                    alPengirim: datappm.alamatTrader,
                    kdposPengirim: datappm.kodeposTrader,
                    telpPengirim: '-',
                    nmPenerima: datappm.namaPartner,
                    alPenerima: datappm.alamatPartner,
                    kdposPenerima: '-',
                    telpPenerima: '-',
                    noRegUpi: dataMutu.upiRegNo,
                    nmUpi: dataMutu.upiNama,
                    alUpi: dataMutu.upiAlamat,
                    telpUpi: dataMutu.upiTelp,
                    deskripsiProduk: dataMutu.mutuDesk,
                    spesiesProduk: dataMutu.mutuJnsProduk,
                    kdProduksi: '-',
                    tglProduksi: '-',
                    negaraAsalProduk: dataMutu.mutuNegAsalProduk !== undefined ? dataMutu.mutuNegAsalProduk : '-',
                    wilayahAsalProduk: dataMutu.mutuNegAsalProduk !== undefined ? dataMutu.mutuNegAsalProduk : '-',
                    cultured: '1',
                    culturedArea: dataMutu.mutuArea,
                    wild: '1',
                    catchArea: dataMutu.mutuTangkapArea,
                    kapalTangkap: dataMutu.mutuNamaKapal,
                    processingType: dataMutu.mutuProses,
                    hscode: '-',
                    kondisiBarang: '-',
                    gdColdStorage: '-',
                    temperatureUraian: dataMutu.mutuTemp,
                    ktgrTemperature: dataMutu.mutuTempTipe,
                    konsumsi: datappm.peruntukan,
                    jmlKms: '0',
                    jnsKms: '-',
                    noCnt: '-',
                    sglCnt: '-',
                    noNSglCnt: '-',
                    netto: datappm.netto !== null ? datappm.netto : 0,
                    bruto: datappm.bruto !== null ? datappm.bruto : 0,
                    nmJnsTrans: datappm.angkut !== null ? datappm.angkut : '-',
                    jnsTrans: datappm.moda !== null ? datappm.moda : '-',
                    nmTrans: datappm.angkut !== null ? datappm.angkut : '-',
                    noFlight: datappm.voyage !== null ? datappm.voyage : '-',
                    nmTransLain: datappm.angkut !== null ? datappm.angkut : '-',
                    docRefMuat: '-',
                    tglBerangkat: formatDateString(datappm.tanggalTibaBerangkat),
                    nmNgrTujuan: datappm.negaraPartner,
                    kdNgrTujuan: datappm.negaraPartner,
                    pelAsal: datappm.pelabuhanMuat,
                    pelTujuan: datappm.pelabuhanBongkar,
                    uePermit: '-',
                    ueReg: '-',
                    tglHc: new Date(),
                    addInfo: '-',
                    kotaTtd: datappm.tempatTtd !== null ? datappm.tempatTtd : '-',
                    nmPejabat: valuePejabatOpt.nama,
                    nipPejabat: valuePejabatOpt.nip,
                    jabatan: '-',
                    status: '0'
                }
                // console.log(jsonHcMutu)
                const resSaveDraft = await transaksiService.addHcMutu(jsonHcMutu)
                if (resSaveDraft.data.kode === '200') {
                    dataKomoditi.map(async (detil, index) => {
                        let jsonHcMutuDetil = {
                            trHcMutuDtlPK: {
                                noUrut: detil.trPpkDtlPK.seri,
                                nomorAju: datappm.nomorAju,
                            },
                            nmLatin: detil.namaLatin,
                            jnsAsalProduk: '-',
                            jnsPerlakuan: '-',
                            dtlNoReg: dataMutu.upiRegNo !== null ? dataMutu.upiRegNo : '-',
                            dtlNmUpi: dataMutu.upiNama,
                            dtlJmlKms: detil.jumlah !== null ? detil.jumlah : 0,
                            dtlJnsKms: detil.kodeSatuan !== null ? detil.kodeSatuan : '-',
                            dtlNetto: detil.netto !== null ? detil.netto : 0,
                        }
                        // console.log(jsonHcMutuDetil)
                        await transaksiService.addHcMutuDetail(jsonHcMutuDetil)
                    })
                }

                let dataPpm = { ...datappm, status: '027' }
                await transaksiService.addPpm(dataPpm)
                setShowConfirmProsesDraft(false)
                setshowProsesDraftSuccess(true)
            } else {
                setShowConfirmProsesDraft(false)
                setshowProsesDraftFailed(true)
            }
        } catch (error) {
            console.log(error)
            setshowProsesDraftFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickProsesDraftSuccess = () => {
        setshowProsesDraftSuccess(false)
        // window.location.reload()
        reloadList(0, 10)
    }

    const handleClickProsesDraftFailed = () => {
        setshowProsesDraftFailed(false)
    }

    return (
        <>
            <Modal show={showProsesDraft}
                onHide={handleCloseProsesDraft}
                backdrop='static'
                keyboard={false}
                size="lg"
                centered
            >
                <Modal.Header>
                    <h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Pejabat Penandatangan</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPejabatTtd}
                                value={valuePejabatOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePejabatOpt}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => SavePenugasan(dataDisposisi)}>Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseProsesDraft}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmProsesDraft &&
                <SweetAlert
                    title="Proses Draft SMKHP?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProsesDraft}
                    onCancel={handleCloseConfirmProsesDraft}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesDraftSuccess &&
                <SweetAlert
                    title="Draft SMKHP Berhasil"
                    success
                    onConfirm={handleClickProsesDraftSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesDraftFailed &&
                <SweetAlert
                    title="Draft SMKHP Gagal"
                    danger
                    onConfirm={handleClickProsesDraftFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalProsesDraft